import { useTranslation } from "react-i18next";
import { Inbox, FileText } from "lucide-react";
import { useCompanyDateFormat } from "../../../../utils/hooks/company";
import { getUploadUrl } from "../../../../utils/helpers/upload";
import { dateTimeFormat } from "../../../../utils/helpers/date";

function Documents({ user }: any) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    const documents: any[] = user?.documents ?? [];

    if (documents.length === 0) {
        return (
            <div className="tw-flex tw-flex-col tw-text-neutral-500 tw-justify-center tw-items-center tw-py-8 tw-border tw-border-dashed tw-rounded-lg">
                <Inbox />
                <p className="tw-text-muted-foreground">{t("no-data")}</p>
            </div>
        );
    }

    return (
        <div className="tw-border tw-rounded-xl tw-overflow-hidden">
            <ul className="tw-divide-y">
                {documents.map((doc: any) => (
                    <li key={doc.id} className="tw-flex tw-items-center tw-gap-3 tw-px-5 tw-py-4 hover:tw-bg-muted/30 tw-transition-colors">
                        <FileText className="tw-h-4 tw-w-4 tw-text-muted-foreground tw-shrink-0" />
                        <div className="tw-min-w-0 tw-flex-1">
                            <a
                                href={getUploadUrl(doc.document)}
                                target="_blank"
                                rel="noreferrer"
                                className="tw-text-sm tw-font-medium tw-text-primary tw-underline tw-truncate tw-block"
                            >
                                {doc.name}
                            </a>
                            {doc.createdAt && (
                                <p className="tw-text-xs tw-text-muted-foreground tw-mt-0.5">
                                    {dateTimeFormat(doc.createdAt, dateFormat)}
                                </p>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Documents;
